module.exports = __webpack_public_path__ + "static/media/14_insideyourblood.4f256ec7.jpg";